import { render } from "./StatusOnboardComponent.vue?vue&type=template&id=6ed66438&scoped=true"
import script from "./StatusOnboardComponent.vue?vue&type=script&lang=js"
export * from "./StatusOnboardComponent.vue?vue&type=script&lang=js"

import "./StatusOnboardComponent.vue?vue&type=style&index=0&id=6ed66438&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed66438"]])

export default __exports__